import React from 'react'
import { Link } from "react-scroll";
import "./Navbar.css"

const Navbar = () => {
    return (
        <>

            <section>
                <div className="container-fluid  p-0  d-md-none d-none d-lg-block PositionMain"  >
                    <nav className="navbar navbar-expand-lg navbar p-0 " >
                        <div className="container ">
                            <Link to="main">
                                <div className='p-2 text-center '>
                                    <img className='LogoSize' src={require("../Img/DummyLogo1.png")} alt="Website-logo" title='Website-logo' />
                                    {/* <a href="main" className='text-decoration-none MontserratFont text-white' style={{ fontWeight: "600" }}> BeautySpot</a> */}
                                </div>
                            </Link>
                            <button className="navbar-toggler bg-light" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon" ></span>
                            </button>
                            <div className="collapse navbar-collapse " id="navbarSupportedContent">
                                <ul className="navbar-nav d-flex justify-content-end ">
                                    <li className="nav-item">
                                        <Link className="nav-link" aria-current="page" to="main">Home</Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link className="nav-link " aria-current="page" to="services">Our Services</Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link className="nav-link " aria-current="page" to="aboutus">About Us</Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link className="nav-link " aria-current="page" to="gallery">Gallery</Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link className="nav-link " aria-current="page" to="contact">Contact</Link>
                                    </li>

                                    <li className="nav-item">
                                        <a href="tel:9921589794">
                                            <button className='HeaderBtn'>
                                                Make An Appointment
                                            </button>
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>

                <div className="container-fluid p-0 d-lg-none d-md-block " style={{ backgroundColor: "#D4AF37 " }}>
                    <nav className="navbar navbar-expand-lg p-0 " >
                        <div className="container-fluid p-0 ">
                            <Link to="main">
                                <div className='p-3 '>
                                    <img className='LogoSize' src={require("../Img/DummyLogo1.png")} alt="Website-logo" title='Website-logo' />
                                    {/* <a href="main" className='text-decoration-none MontserratFont text-white' style={{ fontWeight: "600" }}> BeautySpot</a> */}
                                </div>
                            </Link>
                            <button className="navbar-toggler" type="button " data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                                <i className="fa-solid fa-bars " style={{ color: "#fff" }}></i>
                            </button>
                            <div className="collapse navbar-collapse w-100 p-0 " id="navbarNavDropdown">
                                <ul className="navbar-nav d-flex justify-content-start pb-2" >
                                    <li className='nav-item text-start' >
                                        <Link className="text-white text-decoration-none" to="main" > <b className='' style={{ fontWeight: "600", color: "#fff", fontSize: "15px" }}> Home </b> </Link>
                                    </li>

                                    <li className='nav-item text-start ' >
                                        <Link className="text-white text-decoration-none" to="services" > <b className='' style={{ fontWeight: "600", color: "#fff", fontSize: "15px" }} > OUR SERVICES </b> </Link>
                                    </li>

                                    <li className='nav-item text-start ' >
                                        <Link className="text-white text-decoration-none" to="aboutus" > <b className='' style={{ fontWeight: "600", color: "#fff", fontSize: "15px" }} > ABOUT US </b> </Link>
                                    </li>

                                    <li className='nav-item text-start ' >
                                        <Link className="text-white text-decoration-none" to="gallery" > <b className='' style={{ fontWeight: "600", color: "#fff", fontSize: "15px" }} >  GALLERY </b> </Link>
                                    </li>

                                    <li className='nav-item text-start ' >
                                        <Link className="text-white text-decoration-none" to="contact" > <b className='' style={{ fontWeight: "600", color: "#fff", fontSize: "15px" }} > Contact  </b> </Link>
                                    </li>

                                    <li className="nav-item text-start">
                                        <a href="tel:9921589794">
                                            <button className='HeaderBtn'>
                                                Make An Appointment
                                            </button>
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>
            </section>


        </>
    )
}

export default Navbar